import {
  Box,
  Image,
  Text,
  Button,
  Flex,
  Heading,
  Badge,
  IconButton,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { Lamp } from "../types/Lamp";

interface PromoLampCardProps {
  lamp: Lamp;
}

const PromoLampCard = ({ lamp }: PromoLampCardProps) => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const imageSet: Record<string, string[]> = {
    Kiki: ["/assets/koala1.webp", "/assets/koala2.webp", "/assets/koala3.webp"],
    Zuzu: ["/assets/leon1.webp", "/assets/leon2.webp", "/assets/leon3.webp"],
    Nono: ["/assets/perro1.webp", "/assets/perro2.webp", "/assets/perro3.webp"],
  };

  const images = imageSet[lamp.name] || [];
  const discountedPrice = (lamp.price * 0.9).toFixed(0); // 10% de descuento

  const description =
    lamp.name === "Kiki"
      ? "Tranquila y soñadora, acompaña cada noche con ternura y dulzura."
      : lamp.name === "Zuzu"
      ? "Valiente y aventurera, ilumina los sueños de quienes no temen soñar en grande."
      : "Fiel y cariñoso, es el mejor compañero para soñar sin miedo.";

  const prevImage = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Box
      w={{ base: "100%", sm: "90%", md: "85%" }}
      maxW={{ base: "320px", md: "280px" }}
      h={{ base: "auto", md: "480px" }}
      mx="auto"
      border="3px solid #E07A5F"
      borderRadius="lg"
      bg="white"
      boxShadow="md"
      p={4}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
    >
      {/* Carrusel */}
      <Box position="relative" w="100%" h={{ base: "240px", md: "270px" }}>
        <Image
          src={images[index]}
          alt={lamp.name}
          objectFit="contain"
          borderRadius="md"
          boxSize="100%"
          maxH="100%"
          mx="auto"
        />

        <IconButton
          icon={<ChevronLeftIcon boxSize={6} />}
          aria-label="Anterior"
          position="absolute"
          top="50%"
          left="0"
          transform="translateY(-50%)"
          onClick={prevImage}
          variant="ghost"
          size="sm"
          color="#E07A5F"
        />

        <IconButton
          icon={<ChevronRightIcon boxSize={6} />}
          aria-label="Siguiente"
          position="absolute"
          top="50%"
          right="0"
          transform="translateY(-50%)"
          onClick={nextImage}
          variant="ghost"
          size="sm"
          color="#E07A5F"
        />
      </Box>

      <Heading size="md" mt={3} textAlign="center" color="#225059">
        {lamp.name}
      </Heading>

      <Badge colorScheme="green" mt={1}>
        10% Descuento
      </Badge>

      <Flex align="center" justify="center" gap={2} mt={2}>
        <Text as="s" fontSize="sm" color="gray.500">
          ${lamp.price}
        </Text>
        <Text fontWeight="bold" color="#E07A5F" fontSize="lg">
          ${discountedPrice}
        </Text>
      </Flex>

      <Text fontSize="xs" color="gray.600">
        Incluye IVA y envío gratis
      </Text>

      <Text
        fontSize="sm"
        fontWeight="medium"
        color="#225059"
        mt={2}
        textAlign="center"
        px={2}
      >
        {description}
      </Text>

      <Text fontSize="xs" color="green.600" mt={1}>
        Promoción exclusiva por tiempo limitado
      </Text>

      <Button
        mt={4}
        color="#225059"
        borderColor="#225059"
        border="1px solid"
        variant="outline"
        _hover={{ bg: "#225059", color: "white" }}
        size="sm"
        onClick={() =>
          navigate("/customize", {
            state: {
              lamp: {
                ...lamp,
                price: parseInt(discountedPrice, 10),
                isPromo: true,
              },
            },
          })
        }
      >
        Personalizar
      </Button>
    </Box>
  );
};

export default PromoLampCard;
